var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('div',{attrs:{"id":"reader"}}),_c('div',{staticClass:"close",on:{"click":_vm.onclose}},[_vm._v("关闭")])])}
var staticRenderFns = []

export { render, staticRenderFns }